<template>
	<div class="edit_wrap">
		<!-- tab -->
		<div class="add_top">
			<div class="add_tab active_tab">品牌详情</div>
		</div>
		
		<!-- 品牌详情 -->
		<div class="choice_brand mt20 mb20">
			<!-- 中英文名称 -->
			<div class="add_name">
				<div class="c_name">
					<!-- <span class="main_word mr4">*</span> -->
					<span class="form_color">品牌中文名称：</span>
					<span class="f999 f12">{{brandDetail.brandName}}</span>
				</div>
				<div class="e_name">
					<!-- <span class="main_word mr4">*</span> -->
					<span class="form_color">品牌英文名称：</span>
					<span class="f999 f12">{{brandDetail.brandEnname}}</span>
				</div>
				<div class="e_name">
					<!-- <span class="main_word mr4">*</span> -->
					<span class="form_color">品牌介绍：</span>
					<span class="f999 f12">{{brandDetail.brandDesc}}</span>
				</div>
				<div class="e_name">
					<!-- <span class="main_word mr4">*</span> -->
					<span class="form_color">重点商品：</span>
					<span class="f999 f12">{{brandDetail.brandGoodsDesc}}</span>
				</div>
				<div class="e_name">
					<!-- <span class="main_word mr4">*</span> -->
					<span class="form_color">品牌合作品类：</span>
					<span v-for="category in brandDetail.supplierApplyBrandCategories" class="f999 f12">{{category.categoryName}};&nbsp;&nbsp;</span>
				</div>
			</div>
			<!-- 信息验证 -->
			<div v-if="brandDetail.categoryIsBook != 1">
			<el-form :model="brandDetail" label-width="207px" class="demo-ruleForm">
				<!-- 商品是否进口 -->
				<el-form-item label="商品是否进口：">
					<span v-if="brandDetail.goodsType == 1"  class="f999 f12">非进口</span>
					<span v-if="brandDetail.goodsType == 2"  class="f999 f12">进口</span>
			</el-form-item>

          <!-- 品牌经营方式 -->
          <el-form-item label="品牌经营方式：">
			  <span v-if="brandDetail.businessType == 1"  class="f999 f12">自有品牌</span>
			  <span v-if="brandDetail.businessType == 2"  class="f999 f12">代理商</span>
			  <span v-if="brandDetail.businessType == 3"  class="f999 f12">其他</span>
			  <span v-if="brandDetail.businessType == 4"  class="f999">课程</span>
          </el-form-item>
          <!-- 商标注册证电子版 -->
          <el-form-item v-if="brandDetail.businessType == 1 || brandDetail.businessType == 2" label="商标注册证电子版："  prop="trademarkRegistrationCertificateFile">
			  <div>
				  <img @click="previewPic($event)" v-for="rcFile in brandDetail.trademarkRegistrationCertificateFile.split(',')" class="pic_skan" :src="rcFile">
			  </div>
          </el-form-item>
          <!-- 完整授权链证书电子版 -->
          <el-form-item v-if="brandDetail.businessType == 1 || brandDetail.businessType == 2" label="完整授权链证书电子版："  prop="authCertificateFile">
			  <div>
				  <img @click="previewPic($event)" v-for="acFile in brandDetail.authCertificateFile.split(',')" class="pic_skan" :src="acFile">
			  </div>
          </el-form-item>
          <!-- 订货单电子版 -->
          <el-form-item v-if="brandDetail.businessType == 3" label="订货单电子版：" prop="purchaseOrderFile">
			  <div>
				  <img @click="previewPic($event)" v-for="poFile in brandDetail.purchaseOrderFile.split(',')" class="pic_skan" :src="poFile">
			  </div>
          </el-form-item>
          <!-- 报关单扫描件 -->
          <el-form-item v-if="brandDetail.goodsType == 2" v-show="(brandDetail.customsDeclarationFormFile.split(',').length > 0 && brandDetail.customsDeclarationFormFile.split(',')[0]!='')" label="报关单扫描件：" prop="customsDeclarationFormFile">
			  <div>
				  <img @click="previewPic($event)" v-for="cdfFile in brandDetail.customsDeclarationFormFile.split(',')" class="pic_skan" :src="cdfFile">
			  </div>
          </el-form-item>
          <!-- 质检单电子版 -->
          <el-form-item  v-if="brandDetail.registeredCountry==1 && brandDetail.goodsType == 1 && (brandDetail.businessType == 1 || brandDetail.businessType == 2)" label="质检单电子版："  prop="qualityInspectionFile">
			  <div>
				  <img @click="previewPic($event)" v-for="qiFile in brandDetail.qualityInspectionFile.split(',')" class="pic_skan" :src="qiFile">
			  </div>
          </el-form-item>
          <!-- 入境货物检验检疫证明 -->
          <el-form-item v-if="brandDetail.goodsType == 2" v-show="(brandDetail.inspectionQuarantineFile.split(',').length > 0 && brandDetail.inspectionQuarantineFile.split(',')[0]!='')" label="入境货物检验检疫证明：" class="dib" prop="inspectionQuarantineFile">
			  <div>
				  <img @click="previewPic($event)" v-for="iqFile in brandDetail.inspectionQuarantineFile.split(',')" class="pic_skan" :src="iqFile">
			  </div>
          </el-form-item>
          <!-- 质检日期 -->
          <el-form-item v-if="brandDetail.registeredCountry==1 && brandDetail.goodsType == 1 && (brandDetail.businessType == 1 || brandDetail.businessType == 2)" label="质检日期：" prop="qualityInspectionDate">
          	{{ brandDetail.qualityInspectionDate | time}}
          </el-form-item>
				</el-form>
			</div>
			<!-- 保存 -->
			<div class="w60 auto mt120">
				<el-button type="primary" @click="reback()">返回</el-button>
			</div>

			
		</div>
		<!--预览图片-->
		<el-dialog :visible.sync="dialogVisible" size="small">
			<img  width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>

	</div>
</template>

<script type="text/javascript">
	export default {
		data () {
			return {
				// 图片预览
				dialogImageUrl: '',			
        		dialogVisible: false,
				isChoice: true,				// tab 当前页面
				search_result: false,		// 搜索结果弹框
				brand_key: '',			// 品牌关键字搜索
				radio: null,							// 选中的内容
				// 非图书 申请品牌信息
				brandDetail: {
					brandApplyId:  0,                                // 品牌申请id,Integer
					supplierApplyId :  0,                             // 供应商申请id,Integer
					brandName :  "",                                 // 品牌名称,String
					brandEnname :  "",                              // 英文名称,String
					brandDesc :  "",                                 // 品牌介绍,String
					brandGoodsDesc :  "",                            // 重点商品介绍,String
					categoryIsBook : 0,                                // 品类是否为图书,Integer：0否，1是
					registeredCountry : 0,                             // 注册国家,Integer：1中国
					businessType :  1,                                  // 经营方式（1：自有品牌 2：代理商 3：其他）
					goodsType :  1,                                     // 商品类型（1：非进口 2：进口）
					trademarkRegistrationCertificateFile :  "",                    // 商标注册电子版,String
					purchaseOrderFile :  "",                      // 订货单电子版,String
					authCertificateFile :  "",              // 完整授权链证书电子版,String
					qualityInspectionFile :  "",             // 质检单电子版,String
					qualityInspectionDate : 0,                       // 质检日期
					customsDeclarationFormFile :  "",       // 报关单
					inspectionQuarantineFile :  "",          // 入境货物检验检疫证明,String
					taxFormFile :  "",                              // 税单扫描件,String
					goodsFormFile :  "",                          // 商品清单扫描件,String
				}
			}
		},
		mounted () {
            var brandApplyId = this.$route.query.brandApplyId;
            if(brandApplyId){
                this.initBrandDetail(brandApplyId);
			}
		},
		methods: {
            initBrandDetail(brandApplyId){
                var that = this;
                $.get({
                    url: '/suppliers/supplierSettled/findSupplierApplyBrand',
                    data: {
                        brandApplyId: brandApplyId
                    },
                    success: function (result) {
                        if (!result.code) {
                            that.brandDetail = result.data;
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
			reback(){
                //history.go(-1);
                window.close();
			},
			// 预览图片
			previewPic (e) {
				console.log(e)
				this.dialogVisible = true;
				// 获取当前图片地址
				this.dialogImageUrl = e.currentTarget.src;
			}
		},
		computed: {
			amount: function () {
				return 200 - this.addForm.brandDesc.length;
			}
		}
	}

</script>

<style type="text/css" lang="less" scoped>
	.edit_wrap {
		width: 1050px;
	  // height: 4000px;
	  margin: 50px auto;
	  border: 1px solid #eee;
	  .add_top {
	  	width: 100%;
	  	height: 40px;
	  	background-color: #f9f9f9;
	  }
	  .add_tab {
	  	display: inline-block;
	  	width: 170px;
	  	height: 40px;
	  	text-align: center;
	  	line-height: 40px;
	  	color: #666;
	  	font-size: 14px;
	  	cursor: pointer;
	  }
	  .active_tab {
	  	border-bottom: 1px solid #ff4a7d;
	  	color: #ff4a7d;
	  }
	  .add_name {
	  	padding-left: 96px;
	  }
	}
	.choice_brand {
		min-height: 400px;
	}
	.w500 {
		width: 500px;
	}
	.w250 {
		width: 250px;
	}
	.w165 {
		width: 165px;
	}
	.radio_group {
		width: 90%;
		padding-left: 15%;
		max-height: 150px;
		overflow-y: scroll;
	}
	.list_radio {
		margin-top: 10px;
		margin-left: 10%;
		width: 40%;
		overflow: hidden; 
		text-overflow:ellipsis; 
		white-space: nowrap;
	}
	.mt120 {
		margin-top: 120px;
	}
	.result_radio .el-radio + .el-radio {
     margin-left: 10%; 
	}
	.dialog-footer {
		text-align: center;
	}
	.form_color {
		color: rgb(106, 72, 77);
	}
	.c_name, .e_name {
		line-height: 36px;
	}
	.el-form-item {
		margin-bottom: 0;
	}
	.pic_skan {
		width: 150px;
		height: 150px;
		margin-top: 5px;
		border: 1px solid #c0ccda;
		border-radius: 6px;
		box-sizing: border-box;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// brandDetail.vue?2598d8e8